module.exports = __webpack_public_path__ + "static/media/Nokia Asha 230 Red.14ee974f.png";